import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({ message, fullScreen = false }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-12 text-school-muted ${fullScreen ? 'min-h-0 flex-1 bg-school-canvas' : ''}`}
      role="status"
    >
      <span className="h-8 w-8 animate-spin rounded-full border-[3px] border-school-primary border-t-transparent" />
      <span className="text-sm">{message ?? t('school_loading')}</span>
    </div>
  );
};

export default LoadingState;
